import { render, staticRenderFns } from "./FieldEditor.vue?vue&type=template&id=32f7fa68&scoped=true"
import script from "./FieldEditor.vue?vue&type=script&lang=js"
export * from "./FieldEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f7fa68",
  null
  
)

export default component.exports